<template>
  <section class="container mx-auto py-10 md:pt-20 md:pb-15">
    <h2 class="section-heading mb-5 text-center w-full md:w-2/3 mx-auto">
      Create positive impacts through technology and creativity
    </h2>
    <div class="mx-auto text-center mt-6 md:mt-10">
      <NuxtLink
        to="/about/purpose"
        title="Values"
        class="btn btn-md md:btn-lg btn-primary-reverse w-max mx-auto"
      >
        View Our Values
      </NuxtLink>
    </div>
  </section>
</template>

<script setup></script>

<style lang="scss" scoped></style>
